<template>
  <section class="row align-items-start">
    <div class="col-md-9 col-12 row dashboard-group justify-content-start">
      <Earnings />
      <Claims />
      <Refunds />
      <BooksSource />
      <BooksTags />
      <CanceledOnHoldJobs />
      <Summary />
      <TopCompanies />
    </div>
    <div class="col-md-3 col-12 row dashboard-group">
      <RecentReviews />
    </div>
  </section>
</template>

<script>
import Earnings from './subcomponents/cards/Earnings';
import Claims from './subcomponents/cards/Claims';
import Refunds from './subcomponents/cards/Refunds';
import BooksSource from './subcomponents/cards/BooksSource';
import BooksTags from './subcomponents/cards/BooksTags';
import CanceledOnHoldJobs from './subcomponents/cards/CanceledOnHoldJobs';
import Summary from './subcomponents/cards/Summary';
import TopCompanies from './subcomponents/cards/TopCompanies';
import RecentReviews from './subcomponents/cards/RecentReviews';

export default {
  components: {
    RecentReviews,
    TopCompanies,
    Summary,
    CanceledOnHoldJobs,
    BooksTags,
    BooksSource,
    Refunds,
    Claims,
    Earnings,
  },
};
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/components/dashboard/salesDashboard/SalesDashboard.vue